import { db } from '../../firebase/firebaseConfig';
import { collection, addDoc, serverTimestamp, query, where, orderBy, limit, getDocs } from 'firebase/firestore';

const sanitizeForFirestore = (obj) => {
    if (obj === null || obj === undefined) return null;
    if (Array.isArray(obj)) return obj.map(sanitizeForFirestore);
    if (typeof obj === 'object') {
        const sanitized = {};
        Object.keys(obj).forEach(key => {
            sanitized[key] = sanitizeForFirestore(obj[key]);
        });
        return sanitized;
    }
    return obj;
};

export const logAuditAction = async (tenantId, actor, action, resource, details = {}) => {
    try {
        const safeActor = actor || {};
        const path = tenantId ? `tenants/${tenantId}/audit_logs` : 'audit_logs';

        // Ensure no 'undefined' values reach Firestore
        const sanitizedDetails = sanitizeForFirestore(details);

        await addDoc(collection(db, path), {
            tenantId: tenantId || 'unknown_tenant',
            actorId: safeActor.id || safeActor.uid || 'system',
            actorEmail: safeActor.email || 'unknown',
            actorName: safeActor.fullName || safeActor.name || 'System User',
            actorRole: safeActor.role || 'system',
            action,
            resource,
            details: sanitizedDetails,
            timestamp: serverTimestamp()
        });
    } catch (error) {
        // Silent error for audit logs to not block main operation, but log to console in dev
        console.error('Audit Log Error:', error);
    }
};

export const getAuditLogs = async (tenantId, resource = null, limitCount = 50) => {
    let q = query(
        collection(db, 'auditLogs'),
        where('tenantId', '==', tenantId),
        orderBy('timestamp', 'desc'),
        limit(limitCount)
    );

    if (resource) {
        q = query(q, where('resource', '==', resource));
    }

    const snap = await getDocs(q);
    return snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};
